import {
    SELECTED_YEAR_GROUP,
    SELECTED_TEACHER,
    SELECTED_DATE,
    SELECTED_CLASS,
    SELECTED_GROUP,
    SELECTED_STUDENT,
    ALL_STUDENTS,
    ALL_CLASSES
} from '../components/report-filters/filter-constants';
import DateParamHelper from './date-param-helper';

export default class FilterHelper {
    static shouldLoadAllClasses(activeFilters) {
        return (
            activeFilters[SELECTED_DATE].type !== null &&
            activeFilters[SELECTED_CLASS].id &&
            activeFilters[SELECTED_CLASS].id === ALL_CLASSES &&
            activeFilters[SELECTED_STUDENT].id &&
            activeFilters[SELECTED_STUDENT].id === ALL_STUDENTS
        );
    }

    static shouldReloadAllClasses(activeFilters, newActiveFilters) {
        return (
            (activeFilters[SELECTED_YEAR_GROUP].id !==
                newActiveFilters[SELECTED_YEAR_GROUP].id ||
                activeFilters[SELECTED_TEACHER].id !==
                    newActiveFilters[SELECTED_TEACHER].id ||
                activeFilters[SELECTED_CLASS].id !==
                    newActiveFilters[SELECTED_CLASS].id ||
                !DateParamHelper.areDatesEqual(
                    activeFilters[SELECTED_DATE],
                    newActiveFilters[SELECTED_DATE]
                )) &&
            newActiveFilters[SELECTED_STUDENT].id === ALL_STUDENTS &&
            newActiveFilters[SELECTED_CLASS].id === ALL_CLASSES
        );
    }

    static shouldLoadSingleClass(activeFilters) {
        return (
            activeFilters[SELECTED_DATE].type !== null &&
            activeFilters[SELECTED_CLASS].id &&
            activeFilters[SELECTED_CLASS].id !== ALL_CLASSES &&
            activeFilters[SELECTED_STUDENT].id &&
            activeFilters[SELECTED_STUDENT].id === ALL_STUDENTS
        );
    }

    static shouldReloadSingleClass(activeFilters, newActiveFilters) {
        const hasSelectedClassChanged =
            activeFilters[SELECTED_CLASS].id !==
            newActiveFilters[SELECTED_CLASS].id;
        const hasSelectedStudentChanged =
            activeFilters[SELECTED_STUDENT].id !==
            newActiveFilters[SELECTED_STUDENT].id;
        const hasSelectedDateChanged = !DateParamHelper.areDatesEqual(
            activeFilters[SELECTED_DATE],
            newActiveFilters[SELECTED_DATE]
        );
        const hasSelectedGroupChanged =
            activeFilters[SELECTED_GROUP].id !==
            newActiveFilters[SELECTED_GROUP].id;
        const hasActiveFiltersIdChanged =
            hasSelectedClassChanged ||
            hasSelectedStudentChanged ||
            hasSelectedDateChanged ||
            hasSelectedGroupChanged;

        return (
            hasActiveFiltersIdChanged &&
            newActiveFilters[SELECTED_CLASS].id !== ALL_CLASSES &&
            newActiveFilters[SELECTED_STUDENT].id === ALL_STUDENTS
        );
    }

    static shouldLoadStudent(activeFilters) {
        return (
            activeFilters[SELECTED_DATE].type !== null &&
            activeFilters[SELECTED_CLASS].id &&
            activeFilters[SELECTED_CLASS].id !== ALL_CLASSES &&
            activeFilters[SELECTED_STUDENT].id &&
            activeFilters[SELECTED_STUDENT].id !== ALL_STUDENTS
        );
    }

    static shouldReloadStudent(activeFilters, newActiveFilters) {
        return (
            (activeFilters[SELECTED_CLASS].id !==
                newActiveFilters[SELECTED_CLASS].id ||
                activeFilters[SELECTED_STUDENT].id !==
                    newActiveFilters[SELECTED_STUDENT].id ||
                !DateParamHelper.areDatesEqual(
                    activeFilters[SELECTED_DATE],
                    newActiveFilters[SELECTED_DATE]
                )) &&
            newActiveFilters[SELECTED_CLASS].id !== ALL_CLASSES &&
            newActiveFilters[SELECTED_STUDENT].id !== ALL_STUDENTS
        );
    }
}



// WEBPACK FOOTER //
// ./helpers/filter-helper.js